import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular/standalone';

@Component({
  selector: 'app-ott-events-promo',
  templateUrl: './ott-events-promo.page.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OTTEventsPromoPage {
  private readonly navController = inject(NavController);
  private readonly modalController = inject(ModalController);

  send() {
    this.modalController.dismiss();
    this.navController.navigateRoot('tabs/transaction/step-amount');
  }
}
